import convertColorToCss from '../color/convertColorToCss.js';
import convertPtToPx from '../../units/convertPtToPx.js';

/**
 * Converts the Parabo text placeholder specification format to CSS format.
 * @param {object} spec Parabo text placeholder specification data
 * @returns {object} CSS style object
 */
const convertTextSpecToCss = spec => {
  const { color, fontSize } = spec;
  return {
    color: color == null ? undefined : convertColorToCss(color),
    fontFamily: spec.fontName,
    fontSize: fontSize == null ? undefined : convertPtToPx(fontSize),
    // TODO 94 Check all possible values of alignment
    textAlign: spec.alignment,
  };
};

export default convertTextSpecToCss;
